<script>
import getInteresantsRandomImage from '@/utils/get-interesants-random-image'
import Card from './card/Card.vue'
import CardFields from './card/CardFields.vue'
import CardName from './card/CardName.vue'
import CardImages from './card/CardImages.vue'
import CardStatuses from './card/CardStatuses.vue'
import CardNotes from './card/CardNotes.vue'

export default {
  name: 'Interest',
  components: {
    Card,
    CardFields,
    CardName,
    CardImages,
    CardStatuses,
    CardNotes,
  },
  props: {
    interest: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isMobileVersion() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent,
      )
    },
    imageUrls() {
      return [getInteresantsRandomImage()]
    },
    interestClass() {
      return this.isMobileVersion ? 'interest' : ''
    },
  },
}
</script>

<template>
  <div v-if="interest" :class="interestClass">
    <Card>
      <template #right>
        <div v-if="isMobileVersion">
          <div class="interert-mobile-class">
            <CardImages cursor="default" object="contain" :images="imageUrls" />
            <div class="text-sm text-gray-400">
              {{ interest.interestCreatedAt }}
            </div>
          </div>
        </div>
        <div v-else>
          <div class="mb-2 text-sm text-gray-400">
            {{ interest.interestCreatedAt }}
          </div>
          <CardImages cursor="default" object="contain" :images="imageUrls" />
          <div class="mt-2">
            <CardStatuses :status="interest.interestStatus" />
          </div>
        </div>
      </template>
      <template #left>
        <div class="flex mb-2">
          <div class="flex-1">
            <CardName :name="interest.name" />
          </div>
        </div>
        <CardFields class="mb-2" :fields="interest.fields" />
        <CardNotes :notes="interest.notes" />
        <div class="mt-2" v-if="isMobileVersion">
          <CardStatuses :status="interest.interestStatus" />
        </div>
      </template>
    </Card>
  </div>
  <!-- TODO сделать константу -->
  <div v-else>Скелетон</div>
</template>

<style scoped>
.interest {
  margin: 1rem;
}
.interert-mobile-class {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
